angular.module('directives.dashboard').directive('wgtUndeliveredOrders', ['DashboardApiService','$state',
    function (DashboardApiService, $state) {
        return {
            templateUrl: 'directives/dashboard/widgets/wgtUndeliveredOrders/wgtUndeliveredOrders.tpl.html',
            link: function ($scope) {
                $scope.isLoaded = false;
                $scope.hasError = false;
                $scope.loadWidget = function () {
                    DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                        .then(function (response) {
                            if (response.data === '') {
                                //No data, leaving
                                return;
                            }
                            $scope.widgetData = response.data;
                            $scope.isLoaded = true;
                        }, function (response) {
                            $scope.hasError = true;
                        });
                };
                $scope.goToOrder = function(orderId)  {
                    $state.go('order.orderdelivery', { orderId: orderId });
                };
                $scope.abs = function(value) {
                    return Math.abs(value);
                };
                $scope.loadWidget();
            }
        };
    }
]);
